import { UserSettings } from '../OrganizationUser';
import BillSearchView from '../bills/BillSearchView';

export enum WorkspaceNotifications {
  BILL_REAL_TIME = 'realTimeBillNotification',
  BILL_DAILY = 'dailyBillNotification',
  BILL_WEEKLY = 'weeklyBillNotification',
  COMMITTEE_BILL_REAL_TIME = 'realTimeCommitteeBillNotification',
  COMMITTEE_BILL_DAILY = 'dailyCommitteeBillNotification',
  COMMITTEE_BILL_WEEKLY = 'weeklyCommitteeBillNotification',
  SEARCH_HOURLY = 'hourlySearchNotification',
  SEARCH_DAILY = 'dailySearchNotification',
  SEARCH_WEEKLY = 'weeklySearchNotification',
  COLLABORATION = 'collaborationNotification',
  MENTION = 'mentionNotification',
}

export type WorkspaceNotificationFlags = {
  [K in WorkspaceNotifications]: boolean | null | undefined;
};

export interface UserWorkspaceSettings extends WorkspaceNotificationFlags {
  organizationUserId: number;
  teamId: number;
  billSearchView?: BillSearchView;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface AllNotificationSettingsResponse {
  userSettings: UserSettings;
  userWorkspaceSettings: UserWorkspaceSettings[];
}
